export default __webpack_public_path__ + "static/media/icon-admin-blue.5405ffa0.svg";